export enum SentenceSentiment {
	STRONGLY_NEGATIVE = 0,
	NEGATIVE = 1,
	NEUTRAL = 2,
	POSITIVE = 3,
	STRONGLY_POSITIVE = 4
}